import type { PayloadOf, TypedEvent } from '$domain/events';
import type { Reducer } from '$domain/reducers/reduce';

export interface OnboardingState {
  completed: boolean;
  directions: { directionId: string; label: string }[];
  expressions: { directionRef: string; label: string }[];
  targetBehaviors: { behaviorId: string; label: string }[];
  placementRitualDone: boolean;
  /** True once the single sanctioned re-offer has been made (spec §14). */
  placementReoffered: boolean;
  betaArm: 'replaced' | 'notReplaced' | null;
}

const EMPTY: OnboardingState = {
  completed: false,
  directions: [],
  expressions: [],
  targetBehaviors: [],
  placementRitualDone: false,
  placementReoffered: false,
  betaArm: null,
};

export const onboardingReducer: Reducer<OnboardingState> = {
  name: 'onboarding',
  initial: EMPTY,
  handles: ['onboarding.completed', 'placement.reoffered'],
  apply(state, event) {
    if (event.type === 'onboarding.completed') {
      const payload = event.payload as PayloadOf<'onboarding.completed'>;
      return {
        ...state,
        completed: true,
        directions: payload.directions,
        expressions: payload.expressions,
        targetBehaviors: payload.targetBehaviors,
        placementRitualDone: payload.placementRitualDone,
        betaArm: payload.betaArm ?? null,
      };
    }

    // Spec §14 makes this a provable one-time ritual: once recorded, another
    // event changes nothing, so the app can never derive a second nag from the log.
    if (state.placementReoffered) return state;
    return { ...state, placementReoffered: true };
  },
};
